import { render, staticRenderFns } from "./CollegeOrderManagementView.vue?vue&type=template&id=bb09fbf6"
import script from "./CollegeOrderManagementView.vue?vue&type=script&lang=js"
export * from "./CollegeOrderManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports